/*
  POLNISCHE UND DAENISCHE SPRACHKACHEL - FLAGGE UND ZEILE NACHTRAGEN

  Warum es diese Datei gibt
  -------------------------
  `sections/ol-sprachen.liquid` baut den Bento-Kasten "Der Shop spricht
  Ihre Sprache". Jede Kachel traegt zwei Dinge, die dort fest
  verdrahtet sind, weil sie bewusst NICHT uebersetzt werden:

    1. die Flagge als Inline-SVG (kein Emoji - Windows hat keine
       Flaggen-Emoji, siehe Kopfkommentar der Sektion),
    2. eine kurze Zeile in der Sprache der Kachel selbst.

  Beides steht in je einem `case` ueber `sprache.iso_code`, und beide
  `case` kennen nur de, en, it, es, fr und tr. Seit der Shop auch
  Polnisch und Daenisch spricht, laufen diese beiden Kacheln in den
  `else`-Zweig: sie zeigen die neutrale Weltkugel und stehen ganz ohne
  Text da - neben fuenf Kacheln, die beides haben, faellt das sofort
  auf.

  Die beiden Zweige gehoeren in die Sektion. Nur ist die Datei 34 KB
  gross, und das Werkzeug, mit dem dieses Theme gepflegt wird, schreibt
  nur noch rund 19 KB am Stueck - dieselbe Lage wie bei
  bsfa-vergleich.liquid, ol-anleitung.liquid und styles.css (siehe
  snippets/ol-nacht-start.liquid).

  Deshalb traegt dieses Skript die zwei fehlenden Stellen im Browser
  nach. Das ist ein Nachbessern, kein Ersatz: wird die Sektion einmal
  wieder am Stueck schreibbar, gehoeren pl und da in die beiden `case`
  dort - dann kann diese Datei ersatzlos weg, zusammen mit ihrer Zeile
  in ol-nacht-start.liquid.

  Was es tut
  ----------
  Es sucht die Kacheln (.ol-spr__karte) und liest je Kachel den
  Sprachcode - bei den Knopfkacheln aus dem `value` des Absendeknopfes,
  bei der Tafel der aktuellen Sprache aus dem `lang` des Eigennamens.
  Nur fuer pl und da wird etwas getan, und auch dort nur, was fehlt:

    - Die Zeile wird NUR angelegt, wenn die Kachel noch keine
      .ol-spr__zeile hat. Steht dort schon Text - weil die Sektion die
      Zweige eines Tages selbst mitbringt -, ruehrt das Skript sie
      nicht an. Doppelter Text kann so nicht entstehen, auch nicht,
      wenn das Skript zweimal laeuft.
    - Die Flagge wird NUR ersetzt, wenn dort wirklich die Weltkugel
      steht. Erkennungsmerkmal ist die Ellipse in ihrem SVG, die keine
      der echten Flaggen hat.

  Das Flaggen-Markup ist Zeichen fuer Zeichen aus snippets/ol-flagge.liquid
  uebernommen, wo pl und da laengst stehen. Wer es dort aendert, sollte es
  hier mitziehen.

  Der Text wird ueber textContent gesetzt, nie ueber innerHTML: er ist
  damit unter allen Umstaenden Text und niemals Markup.

  Faellt das Skript aus, bleibt es bei Weltkugel und leerer Kachel -
  unschoen, aber nicht kaputt.
*/
(function () {
  'use strict';

  var TABELLE = {
    pl: {
      zeile: 'Sklep i instrukcje po polsku. Kod aktywacyjny i faktura przychodzą e-mailem – licencja wieczysta zamiast abonamentu.',
      flagge: '<svg viewBox="0 0 60 40" role="presentation" focusable="false"><rect width="60" height="40" fill="#DC143C"/><rect width="60" height="20" fill="#F1F2F1"/></svg>'
    },
    da: {
      zeile: 'Butikken og vejledningerne på dansk. Aktiveringskode og faktura kommer på e-mail – en permanent licens, ikke et abonnement.',
      flagge: '<svg viewBox="0 0 60 40" role="presentation" focusable="false"><rect width="60" height="40" fill="#C8102E"/><path d="M20 0V40M0 20H60" stroke="#FFFFFF" stroke-width="7"/></svg>'
    }
  };

  // Sprachcode einer Kachel. Zwei Wege, weil es zwei Bauarten gibt:
  // die anderen Sprachen sind Absendeknoepfe (name="locale_code"), die
  // aktuelle Sprache ist eine Tafel ohne Knopf.
  function code(karte) {
    if (karte.tagName === 'BUTTON' && karte.getAttribute('name') === 'locale_code') {
      var wert = karte.getAttribute('value') || '';
      if (wert) return wert.slice(0, 2).toLowerCase();
    }
    var name = karte.querySelector('.ol-spr__name[lang]');
    if (name) {
      var l = name.getAttribute('lang') || '';
      if (l) return l.slice(0, 2).toLowerCase();
    }
    return '';
  }

  // Die Zeile sitzt in beiden Bauarten an derselben Stelle: unter der
  // Kopfzeile und - wo es einen gibt - vor dem Fuss mit dem Pfeil.
  function zeile(karte, text, sprache) {
    if (karte.querySelector('.ol-spr__zeile')) return;
    var span = document.createElement('span');
    span.className = 'ol-spr__zeile';
    span.setAttribute('lang', sprache);
    span.textContent = text;
    var fuss = karte.querySelector('.ol-spr__fuss');
    if (fuss && fuss.parentNode === karte) {
      karte.insertBefore(span, fuss);
    } else {
      karte.appendChild(span);
    }
  }

  function flagge(karte, markup) {
    var kasten = karte.querySelector('.ol-spr__flagge');
    if (!kasten) return;
    var svg = kasten.querySelector('svg');
    // Nur die Weltkugel weicht. Sie ist die einzige, die eine Ellipse
    // fuehrt; steht dort schon eine echte Flagge, bleibt sie stehen.
    if (!svg || !svg.querySelector('ellipse')) return;
    kasten.innerHTML = markup;
  }

  function lauf(wurzel) {
    var bereich = wurzel && wurzel.querySelectorAll ? wurzel : document;
    var karten = bereich.querySelectorAll('.ol-spr__karte');
    for (var i = 0; i < karten.length; i++) {
      var karte = karten[i];
      var c = code(karte);
      var eintrag = TABELLE[c];
      if (!eintrag) continue;
      zeile(karte, eintrag.zeile, c);
      flagge(karte, eintrag.flagge);
    }
  }

  function start() {
    lauf(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  // Im Theme-Editor wird ein Abschnitt neu gezeichnet, ohne dass die
  // Seite neu laedt. Dann steht wieder die Weltkugel da.
  document.addEventListener('shopify:section:load', function (e) {
    lauf((e && e.target) || document);
  });
})();
